import { all, put, fork, takeEvery, select } from 'redux-saga/effects';
import actions from './actions';
import { get, post } from '@iso/lib/helpers/resApiRequestor';

export function* getS3UploadUrl() {
  yield takeEvery(actions.GET_S3_UPLOAD_URL, function* ({ payload, resolve, reject }) {
    try {
      const apiResult = yield getURLForFileAPI(payload);
      const result = apiResult.data;

      if (result.success) {
        if (resolve) resolve(result.data); // ✅ send back data to caller
      } else {
        if (reject) reject(result.message || 'Failed to get S3 URL');
      }
    } catch (error) {
      if (reject) reject(error);
    }
  });
}

export function* saveFileMetadata() {
  yield takeEvery(actions.SAVE_FILE_METADATA, function* ({ payload, resolve, reject }) {
    try {
      yield put({
        type: actions.SAVING_FILE_METADATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield saveFileMetadataAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        if (resolve) resolve(result.data); // ✅ send back data to caller
      } else {
        if (reject) reject(result.message || 'Failed to upload file');
      }
    } catch (error) {
      if (reject) reject(error);
    }
  });
}

export function* fetchFiles() {
  yield takeEvery(actions.FETCH_FILES, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_FILES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchFilesAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_FILES_SUCCESS,
          loading: false,
          message: result?.message,
          result: result?.data,
          pagination: result?.pagination
        });
      } else {
        yield put({
          type: actions.FETCH_FILES_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_FILES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchFileAccessURL() {
  yield takeEvery(actions.FETCH_FILE_ACCESS_URL, function* ({ id, payload }) {
    try {
      yield put({
        type: actions.FETCHING_FILE_ACCESS_URL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchFileAccessURLAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_FILE_ACCESS_URL_SUCCESS,
          loading: false,
          message: 'Attachment exported successfully.',
          result: result?.data?.url
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_FILE_ACCESS_URL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_FILE_ACCESS_URL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_FILE_ACCESS_URL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}

function getURLForFileAPI(data, roleAuth) {
  return post(`files/presigned-url`, data, null, null, roleAuth);
}

function saveFileMetadataAPI(data, roleAuth) {
  return post(`files`, data, null, null, roleAuth);
}

function fetchFilesAPI(data, pagination, roleAuth) {
  return get(`files`, data, pagination, null, null, roleAuth);
}

function fetchFileAccessURLAPI(id, payload, roleAuth) {
  return post(`files/${id}/access-url`, payload, null, null, roleAuth);
}

export default function* rootSaga() {
  yield all([
    fork(getS3UploadUrl),
    fork(saveFileMetadata),
    fork(fetchFiles),
    fork(fetchFileAccessURL)
  ]);
}
